import React, { useEffect, useRef, useState } from "react";
import { Check, ChevronDown } from "lucide-react";

export default function ReportSelect({ value = "", options = [], onChange, placeholder = "Select" }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const selected = options.find((option) => String(option.value) === String(value));

  useEffect(() => {
    const closeOutside = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) setOpen(false);
    };
    const closeEscape = (event) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", closeOutside);
    document.addEventListener("keydown", closeEscape);
    return () => {
      document.removeEventListener("mousedown", closeOutside);
      document.removeEventListener("keydown", closeEscape);
    };
  }, []);

  return (
    <div ref={rootRef} className="relative min-w-0">
      <button type="button" onClick={() => setOpen((current) => !current)} className={`flex h-10 w-full items-center justify-between gap-3 rounded-xl border bg-white px-3 text-left text-xs font-medium text-slate-700 outline-none transition ${open ? "border-[#d86a78] shadow-[0_0_0_3px_rgba(216,106,120,0.11)]" : "border-[#f2c6cc] hover:border-[#df8794]"}`} aria-haspopup="listbox" aria-expanded={open}>
        <span className="truncate">{selected?.label || placeholder}</span>
        <ChevronDown size={15} className={`shrink-0 text-slate-400 transition-transform duration-200 ${open ? "rotate-180 text-[#d86a78]" : ""}`} />
      </button>

      {open ? (
        <div className="absolute left-0 right-0 top-[calc(100%+7px)] z-[100] overflow-hidden rounded-[14px] border border-rose-100 bg-white p-1.5 shadow-[0_18px_45px_rgba(37,48,78,0.17)]">
          <div role="listbox" className="sidebar-scroll max-h-56 space-y-1 overflow-y-auto overscroll-contain">
            {options.map((option) => {
              const active = String(option.value) === String(value);
              return (
                <button key={`${option.value}-${option.label}`} type="button" role="option" aria-selected={active} onClick={() => { onChange(option.value); setOpen(false); }} className={`flex w-full items-center justify-between gap-2 rounded-[10px] px-3 py-2.5 text-left text-xs transition ${active ? "bg-[#fff0f3] font-semibold text-[#d6536c]" : "font-medium text-slate-600 hover:bg-slate-50 hover:text-[#d86a78]"}`}>
                  <span className="truncate">{option.label}</span>
                  {active ? <Check size={14} className="shrink-0" /> : null}
                </button>
              );
            })}
          </div>
        </div>
      ) : null}
    </div>
  );
}
